const ROYAL_BRANDCODE = 'R';
const CELEBRITY_BRANDCODE = 'C';
const INT_MARKET = 'INT';
const FRA_MARKET = 'FRA';
const marketingScripts = [
	{
		brand: ROYAL_BRANDCODE,
		market: ['usa', 'int'],
		scripts: [
			{
				id: 'tealium',
				src: 'https://tags.tiqcdn.com/utag/rccl/gdp/qa/utag.sync.js',
				strategy: 'afterInteractive',
			},
			{
				id: 'cookie-law',
				src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
				strategy: 'afterInteractive',
				dataAttributes: [
					{
						key: 'document-language',
						value: 'true',
					},
					{
						key: 'domain-script',
						value: '9553c29f-dac9-4391-93be-d8cec16c6054',
					},
					{
						key: 'charSet',
						value: 'UTF-8',
					},
				],
			},
			{
				id: 'tealium-inline',
				inline: `
                  var utag_data = {};
                  window.utag_cfg_ovrd = {noview : true};
                  (function(a,b,c,d) {
                    a='https://tags.tiqcdn.com/utag/rccl/gdp/qa/utag.sync.js';
                    b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
                    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
                  })();
                `,
				strategy: 'afterInteractive',
			},
		],
	},
];

const MARKETING_SCRIPT_ID = {
	appDynamics: 'app-dynamics',
	appDynamicsInline: 'app-dynamics-inline',
	cookieLaw: 'cookie-law',
	oneSignal: 'one-signal',
	oneTrustBanner: 'one-trust-banner',
	autoBlock: 'auto-block',
	optimizely: 'optimizely',
	medallia: 'medallia',
	monetate: 'monetate',
	monetateInline: 'monetate-inline',
	tealium: 'tealium',
	tealiumInline: 'tealium-inline',
	bazaarVoice: 'bazaar-voice',
};

export { CELEBRITY_BRANDCODE, FRA_MARKET, INT_MARKET, MARKETING_SCRIPT_ID, marketingScripts, ROYAL_BRANDCODE };
